import client from "./client";

export const register = (name, email, password) =>
  client.post("/auth/register", { name, email, password }).then((r) => r.data);

export const login = (email, password) =>
  client.post("/auth/login", { email, password }).then((r) => r.data);

export const logout = () => client.post("/auth/logout").then((r) => r.data);

export const getCurrentUser = () =>
  client.get("/auth/me").then((r) => r.data);
